(function () {
  'use strict';
  function init(bar) {
    if (bar.dataset.ready) return;
    var section = document.getElementById('shopify-section-' + bar.dataset.section);
    if (!section) return;
    var main = section.querySelector('[data-add-to-cart-button]');
    var form = main && main.closest('form');
    if (!form) return;
    bar.dataset.ready = 'true';
    var picker = section.querySelector('variant-selects');
    var allSources = picker ? Array.from(picker.querySelectorAll('select.product-variant-select')) : [];
    var sources = allSources.filter(function (source) { return /size/i.test(source.dataset.optionName || ''); });
    var purchaseControls = form.querySelector('.product-form__buttons') || form;
    var prices = JSON.parse(bar.querySelector('[data-eq-prices]').textContent);
    var add = bar.querySelector('[data-eq-add]');
    var status = bar.querySelector('[data-eq-status]');
    var chosen = sources.map(function (source) {
      return source.options.length === 1 || new URL(location.href).searchParams.has('variant');
    });
    var selects = sources.map(function (source, index) {
      var select = document.createElement('select');
      select.className = 'eq-purchase__select';
      select.setAttribute('aria-label', source.dataset.optionName || 'Size');
      var placeholder = new Option(source.dataset.optionName || 'Size', '');
      placeholder.disabled = true;
      select.add(placeholder);
      Array.from(source.options).forEach(function (option) { select.add(new Option(option.textContent.trim(), option.value)); });
      select.value = chosen[index] ? source.value : '';
      select.addEventListener('change', function () {
        chosen[index] = true;
        // Use the existing selector's handler so price, variant, URL and cart stay in sync.
        var wrapper = source.closest('.product-select-wrapper');
        var option = Array.from(wrapper.querySelectorAll('[data-option-value]')).find(function (item) { return item.dataset.optionValue === select.value; });
        if (option) option.click();
        sync();
      });
      bar.querySelector('[data-eq-options]').appendChild(select);
      return select;
    });
    function sync() {
      selects.forEach(function (select, i) {
        if (chosen[i]) select.value = sources[i].value;
        Array.from(select.options).forEach(function (option) {
          if (!option.value) return;
          var variants = picker.productData || [];
          var available = variants.some(function (variant) {
            var optionIndex = allSources.indexOf(sources[i]);
            return variant.available && variant.options[optionIndex] === option.value && allSources.every(function (source, j) {
              return j === optionIndex || variant.options[j] === source.value;
            });
          });
          option.textContent = option.value + (available ? '' : ' — Sold out');
        });
      });
      var id = form.querySelector('[name="id"]').value;
      if (prices[id]) bar.querySelector('[data-eq-price]').innerHTML = prices[id];
      var missing = chosen.some(function (value) { return !value; });
      var busy = main.classList.contains('is-loading') || main.getAttribute('aria-busy') === 'true' || (main.querySelector('.product-form__cart-button-loading') && !main.querySelector('.product-form__cart-button-loading').hidden);
      add.disabled = busy || (!missing && main.disabled);
      add.textContent = busy ? 'Adding…' : (!missing && main.disabled ? 'Sold out' : 'Add to bag');
      var error = section.querySelector('.product-form__error-message-wrapper');
      status.hidden = !error || error.hidden;
      status.textContent = !status.hidden ? error.textContent.trim() : '';
    }
    section.addEventListener('click', function (event) {
      var option = event.target.closest('.variant-popup__option');
      if (!option) return;
      var source = option.closest('.product-select-wrapper').querySelector('select');
      var index = sources.indexOf(source);
      if (index >= 0) chosen[index] = true;
      sync();
    });
    section.addEventListener('variant:changed', sync);
    add.addEventListener('click', function () {
      var missing = chosen.indexOf(false);
      if (missing >= 0) {
        status.textContent = 'Choose your ' + (sources[missing].dataset.optionName || 'size').toLowerCase() + '.';
        status.hidden = false;
        selects[missing].focus();
        return;
      }
      main.click();
      sync();
    });
    var media = matchMedia('(max-width: 749px)');
    function visibility() {
      var rect = purchaseControls.getBoundingClientRect();
      var show = media.matches && rect.bottom <= 0;
      bar.hidden = !show;
      document.body.classList.toggle('eq-purchase-active', show);
    }
    var observer = new MutationObserver(sync);
    observer.observe(form, { attributes: true, childList: true, subtree: true, characterData: true });
    window.addEventListener('scroll', visibility, { passive: true });
    window.addEventListener('resize', visibility, { passive: true });
    window.addEventListener('pageshow', visibility);
    sync(); visibility();
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target !== section) return;
      observer.disconnect();
      window.removeEventListener('scroll', visibility);
      window.removeEventListener('resize', visibility);
      window.removeEventListener('pageshow', visibility);
      document.body.classList.remove('eq-purchase-active');
    });
  }
  function boot() { document.querySelectorAll('[data-eq-purchase]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
}());
